/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Civil_That_Turtle_AcceptInputs */

const fr_civil_that_turtle_accept = /** @type {(inputs: Civil_That_Turtle_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l'exercice`)
};

/**

* @param {Civil_That_Turtle_AcceptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const civil_that_turtle_accept = /** @type {((inputs?: Civil_That_Turtle_AcceptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Civil_That_Turtle_AcceptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_civil_that_turtle_accept(inputs)
});